import { isValidElement, type ReactNode } from "react";

/**
 * 번역 문자열의 {key} 토큰을 values 로 치환한다.
 * React 엘리먼트는 자리표시자(__REACT_ELEMENT_key__)로 두고 렌더 단계에서 실제 노드로 복원한다.
 */
export const replaceTemplateKeys = (
  rawHtml: string,
  values: Record<string, ReactNode | string>
): string => {
  let replaced = rawHtml;

  Object.entries(values).forEach(([key, value]) => {
    const token = new RegExp(`{${key}}`, "g");
    replaced = replaced.replace(
      token,
      isValidElement(value) ? `__REACT_ELEMENT_${key}__` : String(value)
    );
  });

  return replaced;
};
